const ItemStatus = {
  UP_TO_DATE: 0,
  SOON_EXPIRED: 1,
  OVERDUE: 2
};

export default ItemStatus;
